<template>
    <div>
        <!-- 首页 part_1 -->
        <div class="part part_download">
            <el-row>
                <el-col :xs="24" :sm="12" class="download_left">
                    <div class="content">
                        <div class="title font_size_30">店玖盟APP</div>
                        <div class="title font_size_30">赶快注册享受优质服务</div>
                        <div class="tip">使用店玖盟APP</div>
                        <div class="qrcode_wrap">
                            <div class="qrcode_list">
                                <img :src="downloads[0].img[0]"/>
                                <p>ios下载</p>
                            </div>
                            <div class="qrcode_list">
                                <img :src="downloads[0].img[1]"/>
                                <p>安卓下载</p>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" class="download_right">
                    <img src="../../static/other/introDownload.png" class="intro_img"/>
                </el-col>
            </el-row>
        </div>

        <!-- 首页 part_2 -->
        <div class="part part_version">
            <el-row>
                <el-col :xs="24" :sm="24" class="content">
                    <div class="title">店玖盟APP</div>
                    <div class="title">已开启全新版本</div>
                    <div class="title">好用又省心</div>
                    <img src="../../static/other/intro.png"/>
                </el-col>
            </el-row>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                sliders: [],
                images: [
                    {
                        img: require('../../static/other/用户管理.png'),
                        title: "用户管理",
                        content: ["用户消费分析", "用户标签设定"]
                    },
                    {
                        img: require('../../static/other/店铺管理.png'),
                        title: "店铺管理",
                        content: ["店铺模板切换", "店铺商品上架"]
                    },
                    {
                        img: require('../../static/other/数据分析.png'),
                        title: "数据分析",
                        content: ["交易量直观分析", "经营效果智能分析"]
                    }, {
                        img: require('../../static/other/用户构建.png'),
                        title: "用户互动",
                        content: ["营销活动通知", "用户粘连度提升"]
                    },
                    {
                        img: require('../../static/other/品牌渠道.png'),
                        title: "品牌渠道",
                        content: ["打造店铺自主品牌", "品牌多样化管理"]
                    }
                ],
                downloads: [
                    {
                        img: [require('../../static/other/iosDownload.png'), require('../../static/other/andoridDownload.png')],
                    }
                ],
                products: [
                    {
                        img: [require('../../static/other/手机端商品.png'), require('../../static/other/手机端商品SKU.png')],
                        title: "手机端商品展示 满足多规格显示",
                        content: ["商品热销分类显示 分类导航显示所有分类", "热销商品优先排序 商城首页轮播自定义",
                            "商品多规格多价格展示 商品直接在线购买支付"
                        ]
                    }
                ],
                manages: [
                    {
                        img: [require('../../static/other/图片1.png')],
                        title: "小程序+公众号一体化微信商城管理平台",
                        content: ["公众号菜单自定义发布 微信图文图片素材管理", "商品多规格SKU自定义上架 分类自定义设置",
                            "用户管理 用户自定义标签，了解用户消费行为",
                            "订单管理 实时掌握商品交易详情", "物流闪电发货 实时掌握物流追踪状态",
                        ]
                    }
                ],
                spec: {
                    img: require('../../static/other/arrow.png'),
                    product: [
                        {
                            img: require('../../static/other/手指.png'),
                            title: "一键建铺",
                            contents: ["注册一键创建店铺", "开启您的专属店铺"]
                        },
                        {
                            img: require('../../static/other/店铺管理.png'),
                            title: "店铺装扮",
                            contents: ["不同业态打造不同风格", "给用户流畅的视觉体验"]
                        },
                        {
                            img: require('../../static/other/数据分析.png'),
                            title: "营销分析",
                            contents: ["多玩法提升品牌知名度", "优惠福利刺激付费转化"]
                        },
                        {
                            img: require('../../static/other/助力零售.png'),
                            title: "助力零售",
                            contents: ["提供专业产品服务", "帮助线下零售业态提升营销"]
                        }
                    ]
                },
                company: [
                    "企业从事于：互联网整合营销，互联网软件开发，微信公众号，小程序，微商城开发，提供技术支持，是所创业型服务研发公司。",
                    "核心理念：打造移动电子商务平台 ，提供一键式部署，实现简单可靠稳定的商务平台。",
                    "团队作风：我们来自不同地区，因梦想相聚，组建团队，每个团队成员如同人的五官，缺一不可。",
                    "企业精神：以实力为盾，自信为矛。我们坚信成功靠朋友，成长靠对手，成就靠团体。",
                ],
                carousel_height: '550px',
            }
        },
        methods: {},
        mounted() {
            this.sliders = [
                {
                    img: require("../../static/slider/a1.jpg")
                },
                {
                    img: require("../../static/slider/a2.jpg")
                },
                {
                    img: require('../../static/slider/a3.jpg')
                },
                {
                    img: require('../../static/slider/a4.jpg')
                }
            ]
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }

        },
    }
</script>

<style scoped>

    .part{
        background: #73749b;
        padding: 5%;
        color: #fff;
    }
    .part_download .content{
        padding: 15% 10%;
    }
    .part .title{
        font-size: 3em;
        line-height: 1.5em;
        font-weight: bold;
    }
    .tip{
        font-size: 1.25em;
        margin-top: 50px;
        margin-bottom: 20px;
    }
    .qrcode_wrap{
        display: flex;
        justify-content: space-evenly;
    }
    .qrcode_wrap{
        text-align: center;
    }
    .qrcode_list{
        flex: 0 0 40%;
    }
    .qrcode_list img{
        width: 100%;
    }
    .qrcode_wrap p{
        font-size: 1.25em;
    }
    .download_right{
        text-align: center;
    }
    .part_download .intro_img{
        width: 50%;
    }

    /* part_2 */
    .part_version{
        margin-top: 30px;
    }
    .part_version .content{
        text-align: center;
    }
    .part_version .content img{
        margin-top: 50px;
        width: 60%;
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: auto;
        margin: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }

    .font_size_30{
        font-size: 1.875em;
    }


    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {

        .part_download .content{
            padding: 15% 5%;
        }
        .part .title{
            font-size: 1.8em;
            line-height: 1.5em;
        }

        /* part_2 */
        .part_version .content img{
            margin-top: 20px;
            width: 90%;
        }

        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

    }

    .font_size_24 {
        font-size: 1.5em;
    }
</style>